// Google Forms uses emailAddress to prefill its collected-email field.
export function surveyLink(formUrl, email) {
  const url = new URL(formUrl);
  if (email) {
    url.searchParams.set('usp', 'pp_url');
    url.searchParams.set('emailAddress', email);
  }
  return url.toString();
}
